import { render } from "./BelongsToRelationField.vue?vue&type=template&id=6eb48cf7"
import script from "./BelongsToRelationField.vue?vue&type=script&lang=js"
export * from "./BelongsToRelationField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__